import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomDomainService } from 'src/app/global/services/custom-domain.service';
import { FundraiserCardData } from 'src/app/shared/interfaces/fundraiser-card-interface';
import { SearchService } from 'src/app/pages/search/services/search.service';
import { MediaObserver } from '@angular/flex-layout';
import { Tools } from 'src/utilities/tools';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { MediaService } from 'src/app/pages/fundraiser/services/media.service';
import { FundraiserCardService } from 'src/app/shared/services/fundraiser-card.service';
import { CustomBrandingService } from 'src/app/pages/user/custom-branding/services/custom-branding.service';
import { ThemeService } from 'src/app/global/services/theme.service';
import { environment } from 'src/environments/environment';
import { dom } from '@fortawesome/fontawesome-svg-core';
import { ScriptLoaderService } from 'src/app/global/services/script-loader.service';
import { ConnectFundComponent } from '../../../fundraiser/components/shared/connect-fund/connect-fund.component';
import { DonorListShortComponent } from '../../../fundraiser/components/shared/donor-list-short/donor-list-short.component';
import { DonationsZeroComponent } from '../../../fundraiser/components/shared/donations-zero/donations-zero.component';
import { FundraiserDonationComponent } from '../../../fundraiser/components/shared/fundraiser-donation/fundraiser-donation.component';
import { FundraiserUpdateViewComponent } from '../../../fundraiser/components/shared/fundraiser-update-view/fundraiser-update-view.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { FundraiserMediaViewComponent } from '../../../fundraiser/components/shared/fundraiser-media-view/fundraiser-media-view.component';
import { FundraiserAboutComponent } from '../../../fundraiser/components/shared/fundraiser-about/fundraiser-about.component';
import { MatTabsModule } from '@angular/material/tabs';
import { NgImageSliderModule } from 'ng-image-slider';
import { QuillViewComponent } from 'ngx-quill';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OppOwnerComponent } from '../../../fundraiser/components/shared/opp-owner/opp-owner.component';
import { CreatedByComponent } from '../../../fundraiser/components/shared/created-by/created-by.component';
import { OwnerSocialShareComponent } from '../../../fundraiser/components/shared/owner-social-share/owner-social-share.component';
import { MatChipsModule } from '@angular/material/chips';
import { FundraiserLocationComponent } from '../../../fundraiser/components/shared/fundraiser-location/fundraiser-location.component';
import { FundraiserCategoryComponent } from '../../../fundraiser/components/shared/fundraiser-category/fundraiser-category.component';
import { FundraiserComponent } from '../../../fundraiser/components/fundraiser.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FundraiserCardComponent } from '../../../../shared/components/fundraiser-card/fundraiser-card.component';
import { MatDividerModule } from '@angular/material/divider';
import { FlexModule } from '@angular/flex-layout/flex';
import { SubFooterStartAFundraiserComponent } from './common/sub-footer-start-afundraiser/sub-footer-start-afundraiser.component';
import { StartYourFundraiserOrgComponent } from './organisation/start-your-fundraiser-org/start-your-fundraiser-org.component';
import { FundraiserForGlobalOrgComponent } from './organisation/fundraiser-for-global-org/fundraiser-for-global-org.component';
import { MultiTeamFundraisingComponent } from './organisation/multi-team-fundraising/multi-team-fundraising.component';
import { DonationPluginComponent } from './organisation/donation-plugin/donation-plugin.component';
import { FundraisingSiteComponent } from './personal-fundraising/fundraising-site/fundraising-site.component';
import { OrganisationBannerComponent } from './organisation/organisation-banner/organisation-banner.component';
import { FeaturesAndWhyWhydonateComponent } from './common/features-and-why-whydonate/features-and-why-whydonate.component';
import { StartFundraisingForComponent } from './personal-fundraising/start-fundraising-for/start-fundraising-for.component';
import { FeaturedTopicsComponent } from './personal-fundraising/featured-topics/featured-topics.component';
import { StartingAFundraiserComponent } from './personal-fundraising/starting-a-fundraiser/starting-a-fundraiser.component';
import { FeaturedFundraisersHomepageComponent } from './personal-fundraising/featured-fundraisers-homepage/featured-fundraisers-homepage.component';
import { PersonalFundraisingDividedBannerComponent } from './personal-fundraising/personal-fundraising-divided-banner/personal-fundraising-divided-banner.component';
import { PageLoaderComponent } from '../../../../shared/components/page-loader/page-loader.component';
import {
	NgIf,
	NgFor,
	NgClass,
	NgTemplateOutlet,
	CurrencyPipe,
} from '@angular/common';
import { ImageSliderDialogComponent } from 'src/app/pages/fundraiser/components/dialogs/image-slider-dialog/image-slider-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	standalone: true,
	imports: [
		NgIf,
		PageLoaderComponent,
		PersonalFundraisingDividedBannerComponent,
		FeaturedFundraisersHomepageComponent,
		StartingAFundraiserComponent,
		FeaturedTopicsComponent,
		StartFundraisingForComponent,
		FeaturesAndWhyWhydonateComponent,
		OrganisationBannerComponent,
		FundraisingSiteComponent,
		DonationPluginComponent,
		MultiTeamFundraisingComponent,
		FundraiserForGlobalOrgComponent,
		StartYourFundraiserOrgComponent,
		SubFooterStartAFundraiserComponent,
		FlexModule,
		MatDividerModule,
		NgFor,
		FundraiserCardComponent,
		MatButtonModule,
		MatCardModule,
		NgClass,
		ExtendedModule,
		NgTemplateOutlet,
		FundraiserComponent,
		FundraiserCategoryComponent,
		FundraiserLocationComponent,
		MatChipsModule,
		OwnerSocialShareComponent,
		CreatedByComponent,
		OppOwnerComponent,
		MatFormFieldModule,
		QuillViewComponent,
		NgImageSliderModule,
		MatTabsModule,
		FundraiserAboutComponent,
		FundraiserMediaViewComponent,
		MatIconModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		FundraiserUpdateViewComponent,
		FundraiserDonationComponent,
		DonationsZeroComponent,
		DonorListShortComponent,
		ConnectFundComponent,
		CurrencyPipe,
		ImageSliderDialogComponent,
	],
})
export class HomeComponent implements OnInit {
	isContentLoading: boolean = true;
	isPersonalFundraising: boolean = true;
	isOrganisation: boolean = false;
	currentDomain: string = '';
	isCustomDomainFlag: boolean = false;
	isCustomHomePageFlag: boolean = false;
	isCustomFundraiserHomePageFlag: boolean = false;
	currentFundraiser: any = {};
	customHomeData: any = {};
	isViewChanging: boolean = false;
	isCurrentChildFundraiser: boolean = false;
	isLoggedInUserAdmin = false;
	showEdits = false;
	backgroundVideo: string = '';
	defaultBackgroundImage = Tools.getBase64_FundraiserDefaultBg();
	backgroundImage: string = this.defaultBackgroundImage;
	youtubeIframe!: SafeHtml;
	localeSuffix: string | any = '';
	locale!: string;
	defaultProfileImage: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_user/public';
	isDescriptionLoaded: boolean = false;
	appealMediaList: any;
	mediaLength: number = 0;
	isConnectedFundraiserCountLoading: boolean = true;
	connectedFundraisersCount: number = 0;
	fundraiserNoDescription: boolean = false;
	isNewFundraiser = false;
	connectedFundraisersData: any;
	disableTooltip = $localize`:@@connectedFundraiserTooltip:The fundraiser owner has disabled the option to create a connected fundraiser.`;
	isUpdateLoaded: boolean = false;
	fundraiserUpdatesData: any;
	fundraiserUpdatesCount: any;
	fundraiserUpdatesTotalPages: any;
	fundraiserUpdatesList: any;
	cardShadow = '1';
	fundraiserCardData: any;
	isDraftOrClosed: boolean = false;
	daysLeft: number = 0;
	donarDataParent: any;
	hideToggleSwitch = false;
	donorShortData: any;
	fundraiserDescriptionData: any;
	isFundraiserDataLoaded: boolean = false;
	slug = '';
	fontFamily = 'Roboto';
	whydonateSecondaryColor = '#2E2C96';
	isWhydonateSecondaryColor = false;
	customHomeBackground: any;
	customHomeProfileData: any;
	customHomePageData: any;
	customHomeOwnedFundraisers: any;
	customHomeConnectedFundraisers: any;
	customHomeRecentDonations: any;
	customHomeCustomBranding: any;
	userImage: string =
		'https://whydonate.in/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/staging/profile_image/9a5da9ab26cc4d10/public';
	IMAGE_PREFIX =
		'https://whydonate.in/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/';

	IMAGE_POSTFIX = '/public';

	_fundraiserCardDataList!: {
		slug: string;
		fundraiserCardData: FundraiserCardData;
	}[];

	constructor(
		public _searchService: SearchService,
		public _activatedRoute: ActivatedRoute,
		public _router: Router,
		public customDomainService: CustomDomainService,
		public _media: MediaObserver,
		public router: Router,
		public sanitizer: DomSanitizer,
		public fundraiserService: FundraiserService,
		public accountService: AccountService,
		public mediaService: MediaService,
		public _customBrandingService: CustomBrandingService,
		public _fundraiserCardService: FundraiserCardService,
		public _themeService: ThemeService,
		public scriptLoader: ScriptLoaderService,
		public dialog: MatDialog
	) {
		this.locale = this.accountService.getLocaleId();
		this.localeSuffix = this.fundraiserService.getLocaleSuffix(this.locale);
	}

	async ngOnInit(): Promise<void> {
		try {
			// Load the Crisp chat script
			this.scriptLoader.loadCrisp();

			// Extract the domain from the current URL
			const domain = window.location.hostname;
			//const domain = 'niels.whydonate.net';

			// Check if the current domain is a custom domain
			if (this.isCustomDomain(domain)) {
				this.isContentLoading = true;
				this.customDomainService.setIsCustomDomainValue(true);
				this.isCustomDomainFlag = true;
				// Fetch custom domain data
				await this.getCustomDomainData(domain);
			} else {
				this.isContentLoading = false;
			}

			// Check if the current URL includes 'organisation'
			if (this._router.url.includes('organisation')) {
				this.isPersonalFundraising = false;
				this.isOrganisation = true;
			}
		} catch (error) {
			// Handle any errors that occur during initialization
			console.error('Error during ngOnInit:', error);
		}
	}

	// extractDomainFromUrl(url: string): string {
	// 	// Parse the URL to extract the hostname
	// 	try {
	// 		const parsedUrl = new URL(
	// 			url.startsWith('http') ? url : `https://${url}`
	// 		);
	// 		return parsedUrl.hostname.toLowerCase();
	// 	} catch (error) {
	// 		console.error('Invalid URL format:', url, error);
	// 		return url.split(':')[0].toLowerCase(); // Fallback to basic parsing
	// 	}
	// }

	isCustomDomain(domain: string): boolean {
		const officialDomains = environment.OFFICIAL_DOMAINS;
		return !officialDomains.includes(domain);
	}

	/**
	 * Retrieves custom domain settings data for a given domain.
	 * @param domain The custom domain to fetch data for.
	 * @returns A Promise that resolves with the custom domain settings data.
	 */
	async getCustomDomainData(domain: string): Promise<void> {
		//domain = 'alam.whydonate.net';

		try {
			// Initialize a variable to store the custom domain settings data
			let customDomainSettingsData;

			// Fetch custom domain data using the customDomainService
			await this.customDomainService
				.getCustomDomainData(domain)
				.then((res: any) => {
					this.isContentLoading = false;
					customDomainSettingsData = res?.data;

					if (Object.keys(customDomainSettingsData).length != 0) {
						// Extract relevant flags from the response data
						this.isCustomFundraiserHomePageFlag =
							customDomainSettingsData?.is_fundraiser_home;

						this.isCustomHomePageFlag =
							customDomainSettingsData?.is_custom_home;

						//EXTRACT DATA BASED ON CUSTOM HOME PAGE
						if (this.isCustomHomePageFlag) {
							this.customDomainService.setIsCustomHomeFlag(true);
							this.customHomePageData =
								customDomainSettingsData?.custom_home_data;
							this.customHomeProfileData = this.customHomePageData?.customData;

							if (
								this.customHomeProfileData?.profile_image.length &&
								this.customHomeProfileData?.profile_image.length > 0
							) {
								this.userImage =
									this.IMAGE_PREFIX +
									this.customHomeProfileData?.profile_image +
									this.IMAGE_POSTFIX;
							}

							if (
								this.customHomeProfileData?.image.length &&
								this.customHomeProfileData?.image.length > 0
							) {
								this.backgroundImage =
									this.IMAGE_PREFIX +
									this.customHomeProfileData?.image +
									this.IMAGE_POSTFIX;
							}

							if (this.customHomePageData?.ownedFundraiser?.count > 0) {
								this.customHomeOwnedFundraisers =
									this._fundraiserCardService.filterFundraiserCardDataList(
										this.customHomePageData?.ownedFundraiser?.list
									);
							}

							if (this.customHomePageData?.connectedFundraiser?.count > 0) {
								this.customHomeConnectedFundraisers =
									this.customHomePageData?.connectedFundraiser;

								this.customHomeConnectedFundraisers =
									this._fundraiserCardService.filterFundraiserCardDataList(
										this.customHomePageData?.connectedFundraiser?.list
									);
							}

							if (this.customHomePageData?.donorList.length > 0) {
								this.customHomeRecentDonations =
									this.customHomePageData?.donorList;
							}

							if (
								customDomainSettingsData?.custom_branding?.apply_custom_branding
							) {
								this.customHomeCustomBranding =
									customDomainSettingsData?.custom_branding;

								this.setCustomBrandingCustomHome(this.customHomeCustomBranding);
							}
							this.customHomeCustomBranding =
								customDomainSettingsData?.custom_branding;

							this.setCustomBrandingCustomHome(this.customHomeCustomBranding);
						}

						//EXTRACT DATA BASED ON FUNDRAISER AS CUSTOM HOME
						if (this.isCustomFundraiserHomePageFlag) {
							this.customDomainService.setIsFundAsCustomHomePage(true);
							this.slug =
								customDomainSettingsData?.fundraiser_data?.fudraiserDetails?.slug;
							this.currentFundraiser =
								customDomainSettingsData?.fundraiser_data?.fudraiserDetails;
							this.fundraiserDescriptionData =
								customDomainSettingsData?.fundraiser_data?.description;

							this.fundraiserUpdatesData =
								customDomainSettingsData?.fundraiser_data?.updates;

							this.fundraiserUpdatesCount =
								customDomainSettingsData?.fundraiser_data?.updates?.totalDoc;

							this.fundraiserUpdatesTotalPages =
								customDomainSettingsData?.fundraiser_data?.updates?.totalPages;

							this.isFundraiserDataLoaded = true;
							this.isDescriptionLoaded = true;
							this.isConnectedFundraiserCountLoading = false;
							this.isUpdateLoaded = true;

							// Set fundraiser card object for donation card
							this.fundraiserCardData =
								this._fundraiserCardService.filterFundraiserCardDataList([
									this.currentFundraiser,
								])[0]?.fundraiserCardData;

							//SET BACKGROUND
							this.loadBackgroundInView();

							this.fundraiserService
								.getConnectedFundraisers(this.slug, 1)
								.subscribe((connectedFundraisersRes: any) => {
									this.connectedFundraisersData =
										this.fundraiserService.getConnectedFundraisersObj(
											connectedFundraisersRes['data']
										);
									this.connectedFundraisersCount =
										connectedFundraisersRes['data'].count || 0;

									this.isConnectedFundraiserCountLoading = false;
								});

							this.fundraiserService
								.getDonorShort(this.slug, this.locale)
								.subscribe((response: any) => {
									if (response && response?.data?.result?.result) {
										this.donorShortData = response;
										this.donarDataParent = Object.keys(
											response?.data?.result?.result
										)?.length;
									}
								});

							// Set Custom Branding
							this.setCustomBranding(this.currentFundraiser);
						}

						this.isContentLoading = false;
					} else {
						this.isCustomDomainFlag = false;
						this.customDomainService.setIsCustomDomainValue(false);
					}
				})
				.catch((err) => {
					console.error(err);
					customDomainSettingsData = {};
					this.isCustomDomainFlag = false;
					this.customDomainService.setIsCustomDomainValue(false);
				});
		} catch (error) {
			// Handle any errors that occur during the data retrieval process
			console.error('Error fetching custom domain data:', error);
		}
	}

	routeToMarkFundraiserFraudulent() {
		let connectedUrl = 'fundraising/mark-fundraiser-fraudulent/' + this.slug;
		Tools.setPreviousPath(connectedUrl);
		this.router.navigate([connectedUrl]);
	}

	routeToSearch(type: string = '') {
		this.router.navigate(['search'], { state: { type: type } });
	}

	loadBackgroundInView() {
		if (this.isCurrentChildFundraiser) {
			if (
				this.currentFundraiser?.background?.image !== '' ||
				this.currentFundraiser?.background?.video !== ''
			) {
				this.backgroundImage = this.currentFundraiser?.background?.image;
				this.backgroundVideo = this.currentFundraiser?.background?.video;
				this.youtubeIframe = this.checkVideoUrl(
					this.currentFundraiser?.background?.video
				);
				return;
			}
			if (this.currentFundraiser?.parent?.background != null) {
				this.backgroundImage =
					this.currentFundraiser?.parent?.background?.image;
				this.backgroundVideo =
					this.currentFundraiser?.parent?.background?.video;
				this.youtubeIframe = this.checkVideoUrl(
					this.currentFundraiser?.parent?.background?.video
				);

				return;
			}
			if (this.currentFundraiser?.root_fundraiser?.background != null) {
				this.backgroundImage =
					this.currentFundraiser?.root_fundraiser?.background?.image;
				this.backgroundVideo =
					this.currentFundraiser?.root_fundraiser?.background?.video;
				this.youtubeIframe = this.checkVideoUrl(
					this.currentFundraiser?.root_fundraiser?.background?.video
				);

				return;
			}
		} else if (this.currentFundraiser?.background) {
			this.backgroundVideo = this.currentFundraiser?.background?.video;
			this.backgroundImage = this.currentFundraiser?.background?.image;
			this.youtubeIframe = this.checkVideoUrl(
				this.currentFundraiser?.background?.video
			);
		}
	}

	checkVideoUrl(url: string) {
		// Vimeo link pattern
		const vimeoPattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;

		// YouTube link pattern
		const youtubePattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;

		if (url?.match(vimeoPattern)) {
			return this.generateVimeoIframe(url);
		} else if (url?.match(youtubePattern)) {
			return this.generateYouTubeIframe(url);
		} else {
			return 'unknown';
		}
	}

	generateVimeoIframe(videoLink: string): SafeHtml {
		const vimeoVideoId = this.getVideoIdVimeo(videoLink);

		const angularTag = `
		<style>
		.embed-container {
			--video--width: 1920;
			--video--height: 1080;

			position: relative;
			padding-bottom: calc(var(--video--height) / var(--video--width) * 100%); /* 41.66666667% */
			overflow: hidden;
			max-width: 100%;
			max-height: 100%;
			background: black;
		}

		.embed-container iframe,
		.embed-container object,
		.embed-container embed {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
		</style>
		<div class='embed-container'>
			<iframe
				width="560"
				height="315"
				src="https://player.vimeo.com/video/${vimeoVideoId}"

				srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://player.vimeo.com/video/${vimeoVideoId}?autoplay=1&muted=1><img src=https://vumbnail.com/${vimeoVideoId}.jpg><span>▶</span></a>"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
		`;

		// Sanitize the HTML tag using DomSanitizer
		const safeHTML = this.sanitizer.bypassSecurityTrustHtml(angularTag);

		return safeHTML;
	}

	generateYouTubeIframe(videoLink: string): SafeHtml {
		const videoId = this.getVideoIdYoutube(videoLink);
		const angularTag = `
		<iframe
			loading="lazy"
			src="https://www.youtube-nocookie.com/embed/${videoId}"
			width="100%"
			height="100%"
			frameborder="0"
			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
			allowfullscreen
			title="The Youtube Video"
		></iframe>`;
		// Sanitize the HTML tag using DomSanitizer
		const safeHTML = this.sanitizer.bypassSecurityTrustHtml(angularTag);

		return safeHTML;
	}

	getVideoIdYoutube(videoLink: string): string {
		// Extract the video ID from the YouTube link
		const pattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;
		const match = videoLink?.match(pattern);
		return match && match[1] ? match[1] : '';
	}

	getVideoIdVimeo(videoLink: string): string {
		// Extract the video ID from the Vimeo link
		const pattern = /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;
		const match = videoLink?.match(pattern);
		return match && match[1] ? match[1] : '';
	}

	fallbackToDefaultImage() {
		this.backgroundImage = this.defaultBackgroundImage;
	}

	routeToParentFundraiser(parentSlug: any) {
		this.router.navigate(['fundraising', parentSlug]);
	}

	handleImageError(event: any) {
		event.target.src = this.defaultProfileImage;
	}

	setConnectedFundriserData() {
		if (this.currentFundraiser && this.currentFundraiser?.appeal_image_list) {
			this.appealMediaList = this.mediaService.getSliderMediaList(
				this.currentFundraiser?.appeal_image_list
			);
			if (
				this.appealMediaList &&
				this.appealMediaList != undefined &&
				this.appealMediaList != null
			) {
				this.mediaLength = this.currentFundraiser?.appeal_image_list.length;
			}
		}
	}

	getFundraiserFullDescription(event: any) {}
	routeToConnectFundraiser() {
		// // localStorage.setItem('previous_path', 'fundraising/connect/' + this.slug);
		let connectedUrl = 'fundraising/connect/' + this.slug;
		Tools.setPreviousPath(connectedUrl);
		this.router.navigate([connectedUrl]);
	}

	viewMore() {}

	loadFullUpdateEvent(updatesId: any) {
		this.isUpdateLoaded = false;
		// Get updates of fundraising
		this.fundraiserService
			.getUpdates(this.slug, this.locale, 1, updatesId)
			.subscribe((updatesData: any) => {
				this.fundraiserUpdatesData = updatesData['data'];
				this.fundraiserUpdatesCount = updatesData['data'].totalDoc;
				this.fundraiserUpdatesTotalPages = updatesData['data'].totalPages;
				this.isUpdateLoaded = true;
			});
	}

	handleRefreshEvent(): void {
		// // Get updates of fundraising
		this.fundraiserService
			.getUpdates(this.slug, this.locale, 1)
			.subscribe((updatesData: any) => {
				this.fundraiserUpdatesData = updatesData['data'];
				this.fundraiserUpdatesCount = updatesData['data'].totalDoc;
				this.fundraiserUpdatesTotalPages = updatesData['data'].totalPages;
				this.isUpdateLoaded = true;
			});
	}

	setCustomBranding(currentFundraiser: any) {
		// Set Custom Branding
		this._customBrandingService.setProfileObj = currentFundraiser?.profile;
		let customSettings = this._customBrandingService.getBrandingObj;

		if (customSettings.secondaryColor == this.whydonateSecondaryColor) {
			this.isWhydonateSecondaryColor = true;
		}

		this.cardShadow = this._customBrandingService.calculateCardShadow(
			customSettings.cardShadow
		);
		this.fontFamily = customSettings.customFont;
		this._themeService.setTheme(
			customSettings?.primaryColor,
			customSettings?.secondaryColor,
			customSettings?.customFont
		);
	}

	setCustomBrandingCustomHome(customBrandingObject: any) {
		// Set Custom Branding

		let customSettings = customBrandingObject;

		if (customSettings.secondary_color == this.whydonateSecondaryColor) {
			this.isWhydonateSecondaryColor = true;
		}

		this.cardShadow = this._customBrandingService.calculateCardShadow(
			customSettings.card_shadow
		);
		this.fontFamily = customSettings?.fonts;
		this._themeService.setTheme(
			customSettings?.primary_color,
			customSettings?.secondary_color,
			customSettings?.fonts
		);
	}

	openCustomDialog(clickedImage: any, imageList: any): void {
		this.dialog.open(ImageSliderDialogComponent, {
			data: {
				images: imageList,
				clickedImage,
			},
			maxWidth: '95vw',
			width: '100%',
		});
	}
}
